import React from 'react'

export const SignUp = () => {
  return (
    <div>
      Sign up
    </div>
  )
}
